import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient.ts";

export default function FooterManager() {
  const [footer, setFooter] = useState(null);
  const [socialLinks, setSocialLinks] = useState([]);
  const [services, setServices] = useState([]);
  const [policies, setPolicies] = useState([]);

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    const { data: footerData } = await supabase.from("footer").select("*").single();
    const { data: socialData } = await supabase.from("footer_social_links").select("*");
    const { data: serviceData } = await supabase.from("footer_services").select("*");
    const { data: policyData } = await supabase.from("footer_policies").select("*");

    setFooter(footerData);
    setSocialLinks(socialData);
    setServices(serviceData);
    setPolicies(policyData);
  };

  const updateFooter = async (field, value) => {
    const { error } = await supabase
      .from("footer")
      .update({ [field]: value })
      .eq("id", footer.id);
    if (!error) fetchAllData();
  };

  const updateSocialLink = async (id, field, value) => {
    const { error } = await supabase
      .from("footer_social_links")
      .update({ [field]: value })
      .eq("id", id);
    if (!error) fetchAllData();
  };

  const updateService = async (id, field, value) => {
    const { error } = await supabase
      .from("footer_services")
      .update({ [field]: value })
      .eq("id", id);
    if (!error) fetchAllData();
  };

  const updatePolicy = async (id, field, value) => {
    const { error } = await supabase
      .from("footer_policies")
      .update({ [field]: value })
      .eq("id", id);
    if (!error) fetchAllData();
  };

  if (!footer) return <p style={{ textAlign: "center" }}>Chargement du pied de page...</p>;

  return (
    <div style={{ padding: "40px", background: "#f9f9f9", fontFamily: "Segoe UI, sans-serif" }}>
      <h2 style={{ textAlign: "center", marginBottom: "40px", color: "#343a40" }}>
        Gestion du Pied de Page
      </h2>

      <section style={sectionStyle}>
        <h3 style={sectionTitleStyle}>Informations Générales</h3>
        {Object.entries(footer).map(
          ([key, value]) =>
            key !== "id" &&
            key !== "created_at" && (
              <div key={key} style={formRowStyle}>
                <label style={labelStyle}>{key}:</label>
                <input
                  type="text"
                  value={value || ""}
                  onChange={(e) => updateFooter(key, e.target.value)}
                  style={inputStyle}
                />
              </div>
            )
        )}
      </section>

      <section style={sectionStyle}>
        <h3 style={sectionTitleStyle}>Liens Sociaux</h3>
        {socialLinks.map((link) => (
          <div key={link.id} style={formRowStyle}>
            <label style={labelStyle}>{link.platform}</label>
            <input
              type="text"
              value={link.url}
              onChange={(e) => updateSocialLink(link.id, "url", e.target.value)}
              style={inputStyle}
            />
          </div>
        ))}
      </section>

      <section style={sectionStyle}>
        <h3 style={sectionTitleStyle}>Services</h3>
        {services.map((service) => (
          <div key={service.id} style={formRowStyle}>
            <input
              type="text"
              value={service.title}
              placeholder="Titre"
              onChange={(e) => updateService(service.id, "title", e.target.value)}
              style={inputStyleHalf}
            />
            <input
              type="text"
              value={service.url}
              placeholder="URL"
              onChange={(e) => updateService(service.id, "url", e.target.value)}
              style={inputStyle}
            />
          </div>
        ))}
      </section>

      <section style={sectionStyle}>
        <h3 style={sectionTitleStyle}>Politiques</h3>
        {policies.map((policy) => (
          <div key={policy.id} style={formRowStyle}>
            <input
              type="text"
              value={policy.title}
              placeholder="Titre"
              onChange={(e) => updatePolicy(policy.id, "title", e.target.value)}
              style={inputStyleHalf}
            />
            <input
              type="text"
              value={policy.path}
              placeholder="Chemin"
              onChange={(e) => updatePolicy(policy.id, "path", e.target.value)}
              style={inputStyle}
            />
          </div>
        ))}
      </section>
    </div>
  );
}

// Inline Styles
const sectionStyle = {
  background: "#fff",
  padding: "25px 30px",
  marginBottom: "30px",
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
};

const sectionTitleStyle = {
  fontSize: "20px",
  color: "#222",
  marginBottom: "20px",
  borderBottom: "1px solid #ddd",
  paddingBottom: "5px",
};

const formRowStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: "15px",
  gap: "10px",
};

const labelStyle = {
  width: "150px",
  fontWeight: "500",
  color: "#555",
};

const inputStyle = {
  flex: 1,
  padding: "8px 12px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "15px",
};

const inputStyleHalf = {
  width: "200px",
  padding: "8px 12px",
  border: "1px solid #ccc",
  borderRadius: "6px",
  fontSize: "15px",
};
